module.exports = __webpack_public_path__ + "fonts/45bb78b.ttf";